import { useState } from 'react';

export default function SocialProof() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      quote: 'I run 8 teleconsults per week alongside my full-time ER position in Texas — the membership tier alone covers my student loan payment. Vetuvia gave me the infrastructure to monetize my expertise without opening a clinic.',
      name: 'Dr. Sarah Mitchell',
      title: 'Emergency Veterinarian, DVM',
      specialty: 'Emergency Medicine',
      state: 'Texas',
      avatar: 'from-[#4DB8D4] to-[#2a9ab8]',
    },
    {
      quote: 'As a relief vet in California, I needed a way to build continuity with clients between shifts. Now I have 45 membership clients generating $1,350/month in recurring revenue while I maintain my flexible schedule.',
      name: 'Dr. James Chen',
      title: 'Relief Veterinarian, DVM',
      specialty: 'Small Animal',
      state: 'California',
      avatar: 'from-[#0F1F3D] to-[#1a3a6e]',
    },
    {
      quote: 'I transitioned from associate to independent practice in Florida using Vetuvia as my foundation. The subscription care model brought in 60 patients in my first 90 days — zero overhead, full compliance support.',
      name: 'Dr. Emily Rodriguez',
      title: 'Independent Veterinarian, DVM',
      specialty: 'Exotic & Avian',
      state: 'Florida',
      avatar: 'from-[#4DB8D4] to-[#3aa8c4]',
    },
  ];

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const current = testimonials[currentIndex];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        {/* Diversity Stat Header */}
        <div className="text-center mb-12">
          <p className="text-sm font-medium text-gray-600">
            Representing <span className="text-[#0F1F3D] font-semibold">12+ specialties</span> across <span className="text-[#0F1F3D] font-semibold">30+ states</span>
          </p>
        </div>

        <div className="bg-[#F4F7FB] rounded-3xl p-12 lg:p-16 relative">
          {/* Rating Badge */}
          <div className="inline-flex items-center gap-2 bg-[#0F1F3D] text-white px-4 py-2 rounded-full mb-8">
            <i className="ri-star-fill text-[#4DB8D4]"></i>
            <span className="text-sm font-medium">4.9 Early Access Rating</span>
          </div>

          {/* Quote */}
          <blockquote className="text-3xl lg:text-4xl font-serif italic text-gray-800 leading-relaxed mb-12">
            "{current.quote}"
          </blockquote>

          {/* Author & Navigation */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${current.avatar} flex items-center justify-center`}>
                <span className="text-white text-xl font-semibold">
                  {current.name.split(' ').map(n => n[0]).join('')}
                </span>
              </div>
              <div>
                <p className="text-lg font-semibold text-gray-900">{current.name}</p>
                <p className="text-gray-600 mb-2">{current.title}</p>
                {/* Specialty & State Pills */}
                <div className="flex items-center gap-2">
                  <span className="inline-flex items-center px-3 py-1 rounded-full bg-white/60 text-xs font-medium text-gray-700">
                    {current.specialty}
                  </span>
                  <span className="inline-flex items-center px-3 py-1 rounded-full bg-white/60 text-xs font-medium text-gray-700">
                    {current.state}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <button
                onClick={handlePrev}
                className="w-12 h-12 bg-white border-2 border-gray-200 rounded-lg flex items-center justify-center hover:border-[#4DB8D4] transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-gray-600"></i>
              </button>
              <button
                onClick={handleNext}
                className="w-12 h-12 bg-[#0F1F3D] rounded-lg flex items-center justify-center hover:bg-[#1a2f52] transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line text-white"></i>
              </button>
            </div>
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                  index === currentIndex ? 'bg-[#0F1F3D] w-8' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}